import { UserRole } from '~/types/user'
import { isPagePathAllowed, TELEMEDICINE_HOME } from './telemedicineAccess'

export function pageRedirect(role: UserRole, path: string, pageRoles: UserRole[]): string | null {
    if (!isPagePathAllowed(role, path)) return TELEMEDICINE_HOME

    const home = role === UserRole.fieldMedic ? '/field-posts' : '/'
    if (path === '/' && home !== '/') return home
    if (pageRoles.length && !pageRoles.includes(role)) return home

    return null
}
